'use strict';

const Enum = require('./enum');

/**
 * Each partner on the developer portal can have any number of these access types.
 * They define which documentation users of that partner can access.
 */

/**
 * AccessTypes.
 *
 * @enum
 * @readonly
 */
module.exports.DeveloperAccessTypes = Object.create(Enum, {
  API: { value: 'api', enumerable: true },
  SDK: { value: 'sdk', enumerable: true },
});

/**
 * Each user on the developer portal is assigned a role, which determines
 * what permissions they have.
 */
module.exports.DeveloperRoles = Object.create(Enum, {
  GLOBAL_ADMIN: { value: 'global_admin', enumerable: true },
  PARTNER_ADMIN: { value: 'partner_admin', enumerable: true },
  PARTNER_READER: { value: 'partner_reader', enumerable: true },
  getHumanReadableRole: {
    value: function(role) {
      switch (role) {
        case this.GLOBAL_ADMIN:
          return 'Global Admin';
        case this.PARTNER_ADMIN:
          return 'Partner Admin';
        case this.PARTNER_READER:
          return 'Partner Reader';
      }
    },
    enumerable: false,
  },
  getRoleDescription: {
    value: function(role) {
      switch (role) {
        case this.GLOBAL_ADMIN:
          return 'Can manage partners.';
        case this.PARTNER_ADMIN:
          return 'Can manage credentials and users.';
        case this.PARTNER_READER:
          return 'Can only read documentation.';
      }
    },
    enumerable: false,
  },
});

/**
 * Each partner on the developer portal can have one of these statuses.
 * The status defines which stage of the integration process the partner is in.
 *
 * @see https://augusthome.atlassian.net/wiki/spaces/ST/pages/2391244829/Partner+Portal#Integration-Status
 */
module.exports.DeveloperStatuses = Object.create(Enum, {
  EVALUATING: { value: 'evaluating', enumerable: true },
  BUILDING: { value: 'building', enumerable: true },
  LIVE: { value: 'live', enumerable: true },
  getDescription: {
    value: function(status) {
      switch (status) {
        case this.EVALUATING:
          return 'Cannot create OAuth credentials.';

        case this.BUILDING:
          return 'Can only create one OAuth credential and it expires after 30 days.';

        case this.LIVE:
          return 'Can create multiple OAuth credentials that do not expire.';
      }
    },
    enumerable: false,
  },
});

/**
 * Each partner is charged according to one of our billing models.
 *
 * @see https://augusthome.atlassian.net/wiki/spaces/ST/pages/2391244829/Partner+Portal#Billing-Models
 */
module.exports.DeveloperBillingModels = Object.create(Enum, {
  CONNECTED_MONTHLY: { value: 'connected_monthly', enumerable: true },
  USAGE_MONTHLY: { value: 'usage_monthly', enumerable: true },
  getTitle: {
    value: function(status) {
      switch (status) {
        case this.CONNECTED_MONTHLY:
          return 'monthly connected';

        case this.USAGE_MONTHLY:
          return 'monthly usage';
      }
    },
    enumerable: false,
  },
});
